import { call, put } from 'redux-saga/effects';
import {
  fetchAllThing,
  fetchOneThing,
  fetchZones,
  fetchParksByZone,
} from '../../../services/api';

export function* fetchThings() {
  const response = yield call(fetchAllThing);

  yield put({
    type: 'PARQUE/SET_THINGS',
    payload: response.data,
  });
}

export function* fetchThing({ payload }) {
  const response = yield call(fetchOneThing, payload);

  yield put({
    type: 'PARQUE/SET_THING',
    payload: response.data,
  });
}

export function* fetchZonesByUser() {
  const response = yield call(fetchZones, true);
  yield put({
    type: 'PARQUE/SET_ZONES',
    zones: response.data,
  });
}

export function* fetchZonesByUserCustomer() {
  const response = yield call(fetchZones, false);

  yield put({
    type: 'PARQUE/SET_PARKS_CUSTOMER',
    parks: response.data,
  });
}

export function* fetchParksByUserCustomer({ zoneId, customerId }) {
  const response = yield call(fetchParksByZone, zoneId, customerId);

  yield put({
    type: 'PARQUE/SET_PARKS_CUSTOMER',
    parks: response.data,
  });
}
